import(/* webpackMode: "eager" */ "/home/interim/frontend/app/news/page.tsx");
